import React from 'react'
import { FormattedMessage } from 'react-intl'

export function EmptySeverityThermometerTooltip() {
  return (
    <FormattedMessage
      id="detail_vulnerabilities_noVulnerabilitiesFoundForApplication"
      defaultMessage="No vulnerabilities have been found within the exercised areas of this application."
      children={(msg) => {
        return <div children={msg} />
      }}
    />
  )
}
